import { canv } from "@/canv/global.js";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmContextMenu extends wmBase {
    build() {
        return `
            <div class="wm_contextMenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path d="M10.4999 10.8332C10.9602 10.8332 11.3333 10.4601 11.3333 9.99984C11.3333 9.5396 10.9602 9.1665 10.4999 9.1665C10.0397 9.1665 9.66659 9.5396 9.66659 9.99984C9.66659 10.4601 10.0397 10.8332 10.4999 10.8332Z" fill="#2C2D32"/>
                    <path d="M16.3333 10.8332C16.7935 10.8332 17.1666 10.4601 17.1666 9.99984C17.1666 9.5396 16.7935 9.1665 16.3333 9.1665C15.873 9.1665 15.4999 9.5396 15.4999 9.99984C15.4999 10.4601 15.873 10.8332 16.3333 10.8332Z" fill="#2C2D32"/>
                    <path d="M4.66659 10.8332C5.12682 10.8332 5.49992 10.4601 5.49992 9.99984C5.49992 9.5396 5.12682 9.1665 4.66659 9.1665C4.20635 9.1665 3.83325 9.5396 3.83325 9.99984C3.83325 10.4601 4.20635 10.8332 4.66659 10.8332Z" fill="#2C2D32"/>
                    <path d="M10.4999 10.8332C10.9602 10.8332 11.3333 10.4601 11.3333 9.99984C11.3333 9.5396 10.9602 9.1665 10.4999 9.1665C10.0397 9.1665 9.66659 9.5396 9.66659 9.99984C9.66659 10.4601 10.0397 10.8332 10.4999 10.8332Z" stroke="#2C2D32" stroke-width="0.866667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.3333 10.8332C16.7935 10.8332 17.1666 10.4601 17.1666 9.99984C17.1666 9.5396 16.7935 9.1665 16.3333 9.1665C15.873 9.1665 15.4999 9.5396 15.4999 9.99984C15.4999 10.4601 15.873 10.8332 16.3333 10.8332Z" stroke="#2C2D32" stroke-width="0.866667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.66659 10.8332C5.12682 10.8332 5.49992 10.4601 5.49992 9.99984C5.49992 9.5396 5.12682 9.1665 4.66659 9.1665C4.20635 9.1665 3.83325 9.5396 3.83325 9.99984C3.83325 10.4601 4.20635 10.8332 4.66659 10.8332Z" stroke="#2C2D32" stroke-width="0.866667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_contextMenu");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = () => {
        canv.widgetMenu.hide();
        if (!canv.contextMenu.isOpened) {
            canv.contextMenu.show();
        }
        canv.redraw();
    };
}
